import { ReactElement } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "reactstrap";
import styles from "./CreateButton.module.scss";

const CreateButton = (): ReactElement => {
  const { pathname } = useLocation();

  return (
    <div className={styles.btnContainer}>
      <Link to={`${pathname}/create`}>
        <Button color="success">Create</Button>
      </Link>
    </div>
  );
};

export default CreateButton;
